<!-- <div *ngIf="message"> <iframe width="100%" height="100%" [src]="shibbolethLogoutUrl | safe"></iframe></div> -->

<div class="sign-in-box-container" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <div class="sign-in-box-inner-container">
    <div class="logo-box p-g-12 p-md-6 p-lg-6 p-md-offset-1 p-lg-offset-1 p-g-offset-1 p-g-nopad">
      <div class="form-field p-g-4 p-g-nopad">
        <img src='/assets/images/temp/nbx_login_logo.svg' alt="logo">
      </div>
      <div class="form-field p-g-12 p-g-nopad">
        <h1 translate>Sign in</h1>
        <h2>{{signInWelcomeTextLabel}}</h2>
      </div>
      <div class="logo-box">
        <div class="form-field p-g-11 p-g-nopad" *ngIf="message">
          <div class="logo-box">
            <p class="form-errors alert alert-danger">{{message}} Click here to sign in</p>
          </div>
          <div class="form-field p-g-3 p-g-nopad">
            <button pButton class='sign-in-buttons' (click)="onLogin()" label="Login"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
